import t from"./_baseGetTag.js";import o from"./isObject.js";var r="[object AsyncFunction]",e="[object Function]",n="[object GeneratorFunction]",c="[object Proxy]";function i(i){if(!o(i))return!1;var a=t(i);return a==e||a==n||a==r||a==c}export{i as default};
//# sourceMappingURL=isFunction.js.map
